module.exports = __webpack_public_path__ + "static/img/m_name.89e6d60.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/kc/m_name.png
// module id = QgU+
// module chunks = 7